import CannedMessagesList from './CannedMessagesList'
export default CannedMessagesList
